let AppSettings = {
  LocalDevelopmentApiUrl: "https://localhost:7149/",
  DevelopmentApiUrl: "https://api.development.redeployment.app/",
  ProductionApiUrl: "https://api.redeployment.app/"
};

export { AppSettings }
